import { LEAD_API_KEY, LEAD_API_URL } from '../constants/site';

/**
 * Posts a lead to the Lead Desk intake endpoint.
 * @param {Record<string, string>} fields
 * @returns {Promise<{ ok: boolean, id?: string, duplicate?: boolean }>}
 */
export async function submitLead(fields) {
  const response = await fetch(LEAD_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': LEAD_API_KEY,
    },
    body: JSON.stringify({
      ...fields,
      page: typeof window !== 'undefined' ? window.location.href : '',
      source: fields.source || 'tree7',
      referrer: typeof document !== 'undefined' ? document.referrer : '',
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Could not send your request. Please try again.');
  }

  return data;
}
